import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import numeral from 'numeral'

import StarsRating from '../../../../Shared/StarsRating'
import UserAvatar from '../../../../Shared/UserAvatar/UserAvatar'
import Tooltip from '../../../../Shared/Tooltip'

import JobApplicantRatings from './JobApplicantRatings'

function JobCandidate({ candidate }) {
  const roundedRating = numeral(Number(candidate.rating.rating)).format('0.0')
  const ratingsTooltip = (
    <JobApplicantRatings
      projectsRating={candidate.rating.project_rating}
      buyerRating={candidate.rating.buyer_rating}
    />
  )
  const totalRating = <StarsRating rating={roundedRating} fractions={2} customClass="height-12" readonly />

  return (
    <div className="job-applicant is-inactive">
      <div className="job-applicant__heart" />
      <div className="job-applicant__avatar">
        <UserAvatar
          img={candidate.avatar.url}
          userName={candidate.username}
        />
      </div>
      <div className="job-applicant__info">
        <span>{candidate.username}</span>
        <div className="job-applicant__rating">
          {roundedRating > 0 ? (
            <Tooltip id={`user-ratings-modal-${candidate.username}`} content={ratingsTooltip} className="u-inline-block" place="bottom">
              <Fragment>
                {totalRating}
                <span className="rating"><span className="text-semibold">{roundedRating}</span>/5</span>
              </Fragment>
            </Tooltip>
          ) : (
            <Fragment>
              {totalRating}
              <span className="rating"><span className="text-semibold">N/A</span></span>
            </Fragment>
          )}
        </div>
      </div>
    </div>
  )
}

JobCandidate.propTypes = {
  candidate: PropTypes.shape({
    username: PropTypes.string.isRequired,
    rating: PropTypes.shape({
      buyer_rating: PropTypes.shape({
        avg_rating: PropTypes.number.isRequired,
        count: PropTypes.number.isRequired,
      }).isRequired,
      project_rating: PropTypes.shape({
        avg_rating: PropTypes.number.isRequired,
        count: PropTypes.number.isRequired,
      }).isRequired,
    }).isRequired,
    avatar: PropTypes.shape({
      url: PropTypes.string,
    }),
  }).isRequired,
}

export default JobCandidate
